import { render, staticRenderFns } from "./gold-card-meb.vue?vue&type=template&id=658ede75&scoped=true&"
import script from "./gold-card-meb.vue?vue&type=script&lang=js&"
export * from "./gold-card-meb.vue?vue&type=script&lang=js&"
import style0 from "./gold-card-meb.vue?vue&type=style&index=0&id=658ede75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ede75",
  null
  
)

export default component.exports